import { View } from "@react-pdf/renderer";
import {

  ResumePDFText,
  ProjectPDFLink,

} from "components/Resume/ResumePDF/common";
import { ResumePDFIcon } from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeCertificate } from "lib/redux/types";
import { ResumePDFDescription } from "./common";
import { TemplateSixteenSectionWithSubsections } from "./common/sections";

export const Certificate = ({
  heading,
  certifications,
  themeColor,
  isPDF,
}: {
  heading: string;
  certifications: ResumeCertificate[];
  themeColor: string;
  isPDF: boolean;
}) => {
  return (
    <TemplateSixteenSectionWithSubsections themeColor={themeColor} heading={heading}>
      {certifications.map(
        ({ certificate, certificateLink, descriptions }, idx) => (
          <View 
            key={idx} 
            wrap={false}
            style={idx !== 0 ? { marginTop: spacing["1"] } : {}} 
          >
            <View
              style={{
                ...styles.flexRow,
                gap: spacing["1"], // spacing["2"]
                alignItems: "center",
              }}
            >
              <ResumePDFText bold={true}>{certificate}</ResumePDFText>
              {certificateLink && (
                <ProjectPDFLink src={certificateLink}>
                  <ResumePDFIcon
                    type="url"
                    isPDF={isPDF}
                    themeColor={"black"}
                  />
                </ProjectPDFLink>
              )}
            </View>
            <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
              <ResumePDFDescription items={descriptions} />
            </View>
          </View>
        )
      )}
    </TemplateSixteenSectionWithSubsections>
  );
};
